export const defaultParkingInput = {
  podium_parking_enabled: false,
  underground_parking_enabled: false,
  ratio: 0,
  max_level_underground_parking: 3
};
